export const cert = `-----BEGIN CERTIFICATE-----
MIIFBzCCAu+gAwIBAgIQNzkyMDI2MDQyMzA4NDQ0MTANBgkqhkiG9w0BAQ0FADCB
mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry
aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ
cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz
dHJpZXMuY29tMB4XDTI2MDQyMzA4NDQ0MVoXDTI4MDQyODE0NDI1OFowgcAxCzAJ
BgNVBAYMAktSMQ4wDAYDVQQIDAVTRU9VTDEOMAwGA1UEBwwFU2VvdWwxDzANBgNV
BAoMBkdPTkVMTzELMAkGA1UECwwCSVQxEzARBgNVBAMMCmdvbmVsby5jb20xIDAe
BgkqhkiG9w0BCQEMEWtrbmRvMmFAZ21haWwuY29tMTwwOgYDVQQNDDNyZW5ld2Fs
LW9mLWFiYTJkMTJiMmJkZTc5NDVkOTc4M2ZjNTIxY2RkZjI0NTcwOTkzMzMwggEi
MA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCxGUVDDbxmxxONC1iqvsCdKPJK
WiGOXRZTMqJ9SJ9FYvWbFegXLHN1++MQHeU7/2J8L21MLNvc4jJgWbPNqt1WO3wC
S9DJKK+PEwl6HUWQkT6kW9pbUbsERpthocs3cYNDKk6HCX8rSJ16qD1BqVZrj/4C
2NjWIL2RNg4Nxm/pfmA4RtJHtp/CGfd+H3i8OxS5ml9B2yvsIv3MvJRy+SIlnYrm
96k/cnAXEUdQnON0wyS8ZZ5XFV1dUH2oXpBPO8NGY/JlGuc38ZuMUzOgR+3GzMMx
yb23tvN/oyeGNQM7kk7I0HCFFNtD15OQZepJFm/8FxlTqN9J0snzREmnsL8RAgMB
AAGjIzAhMB8GA1UdIwQYMBaAFJCmULeE1LnqX/IFhBN4ReipdVRcMA0GCSqGSIb3
DQEBDQUAA4ICAQAF4/LZNVlPE57XbvwdroDUcJidQclSPa97ddz6tcSGwYWUoyc6
4zuA486C1TRPFoS4qWKOqclxWSpVYClAmv8D5tHM4BdV8zzC78CdlyzIWbs1B3WA
MwjUbgUk+trwJV1vksw9DRQhB9+MI8ZnJQq6/CWStUz4e0q31PEa9TDYrYXKc8zP
ReYJP8ZDhUO2KcM0E27u7BpXAhX2F/MCPqEInpeyI0YGfOJ3eB1CUrj1w7qC8BXn
Vmguhh06XjJpV9ViMShT7WHKfbPCsYd7Z73wzgAXpkFoWHmiW4EaxVh2fTrXT2Sf
AhYPSyqNZm++A+UHzSmxXZPTdlHlgl3/kl+eqfoL7wMCfsayxAeLoYkxVjazhKGu
MHEGPdL7ozR9Sb6p05l6PVL/Gy0WwCM/favzg9yrBe0AZ4sdU/es2lmoTBMWKwA5
VRQ84SyuYHr6LO7PqmgD5ic0Zo7QRWW3ntfmA4lHmqInfMrg3UZXw8k3ZQuFaEq9
11AYlcX9kaTjFzzWpRmNryWjYhCuAIaBBT6MSBbTPpIJaTrkrwpIgRiEPdVcr+9k
S6me4oB1BY4YEaQvP+Ay8fjKYlF8mmXIzgddLuh0lMd+MN29louLFshHf2h/GntA
P5c4UIEXqHnlzXBlVCQpjzhP8EMrWZjSX5fiz/KMKo05dRTySauRqllTrw==
-----END CERTIFICATE-----
--START INTERMEDIATE CERT--
-----BEGIN CERTIFICATE-----
MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT
MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ
bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG
A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx
emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow
gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0
cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM
EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1
c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU
iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H
YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM
GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH
EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh
0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX
xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1
9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE
ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD
2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX
6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY
5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ
plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S
BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ
eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k
gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT
x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu
pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw
2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp
rbO7BnjW
-----END CERTIFICATE-----
`;
